import { buildRequest } from './request'

const request = buildRequest('/api/front/v1')

export type OSSTokenConfig = {
  accessKeyId: string
  accessKeySecret: string
  bucket: string
  expireTime: number
  region: string
  stsToken: string
}

export async function getOSSToken(): Promise<OSSTokenConfig> {
  const res = await request('/oss/token')
  return res
}

export function getOSSTokenAPI(): string {
  return `/api/front/v1/oss/token`
}
